import { createConfigSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';

export const getCdaasBaseUrl = createConfigSelector('cdaasUrl');

export const getCdaasCulinaryCollectiveUrl = createSelector(
  getCdaasBaseUrl,
  (cdaasBaseUrl) => `${cdaasBaseUrl}/exports/centurion-culinary-collective.json`
);

export const getCdaasCenturionHomepageUrl = createSelector(
  getCdaasBaseUrl,
  (cdaasBaseUrl) => `${cdaasBaseUrl}/exports/centurion-homepage.json`
);
